import React, { useCallback, useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { createSearchParams, NavigateFunction, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import DetailCard from "../../../components/card/DetailCard";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { icons } from "../../../assets/icons/icons";
import StepperCustom from "../../../components/step/Stepper";
import InputTextField from "../../../components/input/inputTextField";
import { SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../utils/app.utils";
import ModalFormSendRequest from "./components/ModalFormSendRequest";
import ListConsultationRequest from "./components/ListConsultationRequest";
import { advisorApi } from "../../../api/advisor/advisor.api";
import { advisorRequestApi } from "../../../api/advisor-request/advisor-request.api";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import TeacherClassRoom from "./TeacherClassRoom";
import ListDocuments from "./components/ListDocuments";
import { RootState } from "../../../store/store";
import StudentProfileCards from "./components/ProfileCard";

type Props = {};

const ChooseAdvisor: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location.pathname;
  const [searchParams] = useSearchParams();
  const params_step = searchParams.get('step');

  const profile_data = useSelector((state: RootState) => state.profile.profile) as any;
  const id_faculty = profile_data?.faculty_one?.id_faculty;
  // console.log(profile_data, 'profile_data')

  const matches = useMediaQuery("(min-width:1440px)");
  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [search, setSearch] = useState<string>("");


  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(20);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const open = useSelector((state: any) => state?.navbar?.open);
  const [tabStep, setTebStep] = useState(0);
  const [isShowModalSendRequest, setIsShowModalSendRequest] =
    useState<boolean>(false);

  const [file, setFile] = useState<any>(null); // For handling file selection
  const [formSendRequest, setFormSendRequest] = useState<{
    advisor_request_name: string;
    advisor_request_desc: string;
    id_advisor: number;
  }>({
    advisor_request_name: "",
    advisor_request_desc: "",
    id_advisor: 0,
  });

  const [dataRequest, setDataRequest] = useState<any>({});
  // const status_reponse: any = "reject";
  const [errorMessage, setErrorMessage] = useState<any[]>([]);

  const getDataAdvisor = useCallback(async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };
    if (search) query.search = search;
    if (id_faculty) query.id_faculty = id_faculty
    const res = await advisorApi.getAllAdvisor(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisor(data.data.items);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setDataAdvisor([]);
    }
  }, [id_faculty, search, page, pageLimit, sortBy, sortType])

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  useEffect(() => {
    getDataAdvisor();
  }, [getDataAdvisor]);

  const getSingleRequest = async () => {
    await advisorRequestApi.getAdvisorRequestByUserLogin().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataRequest(data.data);
      }
    }).catch((err) => {
      console.log(err)
    })

  };

  useEffect(() => {
    getSingleRequest();
  }, []);

  const allStep = [
    {
      name: "ข้อมูลอาจารย์ที่ปรึกษาวิทยานิพนธ์",
      isAccept: false,
      icon: (
        <img
          src={icons.user_square}
          alt="book"
          style={{
            cursor: "pointer",
            filter: tabStep === 0 ? "brightness(0) invert(1)" : "",
          }}
        />
      ),
    },
    {
      name: "ข้อมูลอาจารย์ที่ปรึกษาประจำชั้น",
      isAccept: false,
      icon: (
        <img
          src={icons.user_square}
          alt="folder"
          style={{
            cursor: "pointer",
            filter: tabStep === 1 ? "brightness(0) invert(1)" : "",
          }}
        />
      ),
    },
    {
      name: "การขอคำปรึกษา",
      isAccept: false,
      icon: (
        <img
          src={icons.sms_edit}
          alt="folder"
          style={{
            cursor: "pointer",
            filter: tabStep === 2 ? "brightness(0) invert(1)" : "",
          }}
        />
      ),
    },
    {
      name: "เอกสารประกอบ",
      isAccept: false,
      icon: (
        <img
          src={icons.folder_3}
          alt="folder"
          style={{
            cursor: "pointer",
            filter: tabStep === 3 ? "brightness(0) invert(1)" : "",
          }}
        />
      ),
    },
  ];

  const handleStatus = (status: string) => {
    if (status === "รอพิจารณา") {
      return "pending";
    } else if (status === "ตอบรับเป็นที่ปรึกษา") {
      return "approve";
    } else if (status === "ปฏิเสธคำขอ") {
      return "reject";
    } else if (status === "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง") {
      return "transfer_old_pending";
    } else if (status === "รออาจารย์ที่ปรึกษาใหม่พิจารณาคำร้อง") {
      return "transfer_new_pending";
    } else if (status === "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา") {
      return "end";
    } else {
      return "default";
    }
  };
  //
  const validateForm = () => {
    const errors: string[] = [];

    // Check if required fields are empty
    if (!formSendRequest.advisor_request_name) {
      errors.push("advisor_request_name");
    }

    // Check if required fields are empty
    if (!formSendRequest.advisor_request_desc) {
      errors.push("advisor_request_desc");
    }

    // Check if required fields are empty
    if (!formSendRequest.id_advisor) {
      errors.push("id_advisor");
    }
    if (!file) {
      errors.push("file");
    }

    setErrorMessage(errors);

    // If there are no errors, return true
    return errors.length === 0;
  };

  const handleSave = async (
    advisor_request_name: string,
    advisor_request_desc: string,
    id_advisor: number,
    newFile?: File
  ) => {
    console.log("newFile", newFile);
    if (
      validateForm() &&
      newFile
      // advisor_request_name &&
      // advisor_request_desc &&
      // id_advisor
    ) {
      const formData = new FormData();

      formData.append("file", newFile);
      formData.append("advisor_request_name", advisor_request_name);
      formData.append("advisor_request_desc", advisor_request_desc);
      formData.append("id_advisor", id_advisor.toString());


      try {
        dispatch(unsetLoading());
        const response = await advisorRequestApi.createAdvisorRequest(formData);
        if (response.status < 300) {
          alertSuccess(
            "ส่งคำร้องขอ",
            "ส่งคำร้องขอ เรียบร้อยแล้ว",
            undefined,
            () => {
              setIsShowModalSendRequest(false);
              setFormSendRequest({
                advisor_request_name: "",
                advisor_request_desc: "",
                id_advisor: 0,
              });
              getSingleRequest();
              setFile(null);
            }
          );
        }
      } catch (error) {
        alertError("ส่งคำร้องขอ ไม่สำเร็จ");
      } finally {
        dispatch(unsetLoading());
      }
    }
  };

  const handleCancelRequest = async (id: number) => {
    if (id) {
      alertActive(
        "ยกเลิกส่งคำร้องขอ",
        "ท่านต้องการยกเลิกส่งคำร้องขอ ใช่หรือไม่",
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await advisorRequestApi
            .deleteAdvisorRequest(+id)
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  "ยกเลิกส่งคำร้องขอ เรียบร้อย",
                  undefined,
                  undefined,
                  () => {
                    getSingleRequest();
                    getDataAdvisor();
                  }
                );
              }
            })
            .catch(() => {
              alertError("ส่งคำร้องขอ ไม่สำเร็จ");
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  useEffect(() => {
    if (params_step && !isNaN(+params_step)) {
      setTebStep(+params_step)
    }
  }, [params_step])

  // console.log("dataRequest", dataRequest);
  return (
    <div>
      <ModalFormSendRequest
        setIsOpenModal={(isOpen: boolean) => setIsShowModalSendRequest(isOpen)}
        isOpenModal={isShowModalSendRequest}
        action={"create"}
        file={file}
        setFile={setFile}
        inputValue={formSendRequest}
        setInputValue={setFormSendRequest}
        onSend={() => {
          handleSave(
            formSendRequest.advisor_request_name,
            formSendRequest.advisor_request_desc,
            formSendRequest.id_advisor,
            // file ? file : []
            file ? file[0] : undefined
          );
        }}
        errorMessage={errorMessage}
      />

      <ContentHeading
        title={"อาจารย์ที่ปรึกษา"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <StepperCustom
          step={tabStep}
          setStep={(st) => {
            setTebStep(st);
            navigate({
              pathname: pathname, search: createSearchParams({
                step: String(st)
              }).toString()
            }, { replace: true })
          }}
          stepLabel={allStep}
          view={true}
        />
      </section>

      {tabStep === 0 && (
        <>
          {dataRequest && dataRequest?.id_advisor_request ? (
            <Grid container spacing={2}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{
                  alignSelf: "end",
                }}
              >
                <DetailCard
                  fullname={
                    dataRequest?.first_name + " " + dataRequest?.last_name
                  }
                  email={dataRequest?.email_organization ?? ""}
                  maxStudents={dataRequest?.number_students ?? ""}
                  requestCount={dataRequest?.count_req_all ?? ""}
                  advisorCount={dataRequest?.count_req ?? ""}
                  isSelect={false}
                  status={handleStatus(dataRequest?.status_request)}
                  setIsShowModalSendRequest={setIsShowModalSendRequest}
                  remark={
                    handleStatus(dataRequest?.status_request) === "reject"
                      ? dataRequest?.advisor_refuse
                      : ""
                  }
                  degree={dataRequest?.degree ?? ""}
                  faculty={dataRequest?.faculty ?? ""}
                  year={dataRequest?.year ?? ""}
                  classRoom={dataRequest?.classRoom ?? ""}
                  onCancelRequest={() => {
                    handleCancelRequest(dataRequest?.id_advisor_request);
                  }}
                  image={dataRequest?.file_path_img_emp ?? ""}
                  id_advisor_request={dataRequest?.id_advisor_request}
                />
              </Grid>
            </Grid>
          ) : null}
        </>
      )}

      <section className="w-full mt-4">
        {tabStep === 0 ? (
          <>
            <section className="w-full mt-4">
              <Typography variant="h6">
                กรุณาเลือกอาจารย์ที่ปรึกษาที่ท่านต้องการ
              </Typography>
            </section>

            <div className="w-full grid grid-cols-12 gap-4 mb-4">
              <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-12">
                <InputTextField
                  startAdornment={<SearchOutlined />}
                  placeholder="ค้นหาชื่อ - นามสกุล"
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    debouncedApiCall({
                      searchItem: e.target.value,
                      setItem: setSearch,
                    })
                  }
                />
              </article>
            </div>

            <Grid container spacing={2}>
              {dataAdvisor &&
                dataAdvisor
                  .filter(
                    (advisor) => advisor.id_advisor !== dataRequest?.id_advisor
                  )
                  .map((advisor, index) => (
                    <Grid
                      key={index + 1}
                      item
                      lg={open ? 6 : 4}
                      md={open ? 6 : 4}
                      sm={12}
                      xs={12}
                      sx={{
                        alignSelf: "end",
                      }}
                      onClick={() => {
                        setFormSendRequest({
                          ...formSendRequest,
                          id_advisor: advisor.id_advisor,
                        });
                      }}
                    >
                      <DetailCard
                        fullname={advisor.first_name + " " + advisor.last_name}
                        email={advisor.email_organization ?? ""}
                        maxStudents={advisor.number_students ?? ""}
                        requestCount={advisor.count_req_all}
                        advisorCount={advisor.count_req}
                        isSelect={
                          (handleStatus(dataRequest?.status_request) ===
                            "default" ||
                            handleStatus(dataRequest?.status_request) ===
                            "reject" ||
                            handleStatus(dataRequest?.status_request) ===
                            "end") &&
                          advisor.number_students > 0
                        }
                        status={"default"}
                        setIsShowModalSendRequest={setIsShowModalSendRequest}
                        degree={advisor.degree}
                        faculty={advisor.faculty_names}
                        year={advisor.year}
                        classRoom={advisor.classRoom}
                        image={advisor.file_path}
                      />
                    </Grid>
                  ))}
            </Grid>
          </>
        ) : tabStep === 1 ? (
          <>
            <Grid container spacing={2}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{
                  alignSelf: "end",
                }}
              >
                <StudentProfileCards />
                {/* <TeacherClassRoom /> */}
              </Grid>
            </Grid>
          </>
        ) : tabStep === 2 ? (
          <ListConsultationRequest />
        ) : tabStep === 3 ? (
          <ListDocuments />
        ) : null}
      </section>
    </div>
  );
};

export default ChooseAdvisor;
